export const DIALOG_OPTION = 'DIALOG_OPTION' //设置模态参数
